"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MessageDescriptorPropType = exports.CurrencyPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/*
  react-intl message proptype is not available to import directly:
  @link https://github.com/yahoo/react-intl/blob/b82a899a59c762fcc590e1fa824b87da6ad409d9/src/types.js#L37-L41
*/
var MessageDescriptorPropType = exports.MessageDescriptorPropType = _propTypes["default"].shape({
  id: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string,
  defaultMessage: _propTypes["default"].string
});
MessageDescriptorPropType.propTypeName = 'MessageDescriptorPropType';
var CurrencyPropType = exports.CurrencyPropType = _propTypes["default"].shape({
  style: _propTypes["default"].string.isRequired,
  currency: _propTypes["default"].string.isRequired,
  maximumSignificantDigits: _propTypes["default"].string.isRequired
});
var _default = exports["default"] = MessageDescriptorPropType;